import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { useSelector } from "react-redux";
import { unknownUser } from "../../sysGuardConstants";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { shortenedNumber } from "../../../../components/views/manageDataMap/locationCommonComponents";

// Custom Tooltip Component
const CustomTooltip = ({ active, payload, isUsageFrequency }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        {!isUsageFrequency ? (
          <p>{`${payload[0].payload.name} has ${shortenedNumber(payload[0].value)} alerts`}</p>
        ) : (
          <p>{`The ${payload[0].payload.name} has usage frequency of ${(
            payload[0].value
          ).toFixed(0)}`}</p>
        )}
      </div>
    );
  }
  return null;
};

const CustomBarChart = ({
  applications,
  isDashboardPopup = false,
  isUsageFrequency = false,
}) => {
  const history = useHistory();

  let data = applications.map((app) => {
    const appName = app.appDetails || app.name;
    const abbr = appName
      ? appName
          .split(" ")
          .map((word) => word[0])
          .join("")
          .toUpperCase()
      : "Unknown";

    return {
      name: unknownUser(appName),
      abbr: abbr,
      value: app.alertCount || app.count,
    };
  });

  data = [...data].sort((a, b) => b.value - a.value).slice(0, isDashboardPopup ? 15 : 4);

  const renderHeight = () => (isDashboardPopup ? 650 : isUsageFrequency ? 200 : 118);

  const renderClassName = () =>
    `chart-container-sysguard${isDashboardPopup ? " dashboardPopup" : ""}`;

  return (
    <div className={renderClassName()}>
      <h3 className="chart-title">Applications</h3>
      <ResponsiveContainer width="100%" height={renderHeight()}>
        <BarChart
          data={data}
          barCategoryGap="15%"
          {...(isDashboardPopup && {
            margin: {
              top: 20,
              right: 20,
              bottom: 150,
              left: 100,
            },
          })}
        >
          <XAxis
            dataKey={isDashboardPopup ? "name" : "abbr"}
            tick={{
              fill: "#6787F2",
              fontSize: 12,
              angle: isDashboardPopup ? -30 : 0,
              textAnchor: isDashboardPopup ? "end" : "middle",
            }}
            tickLine={false}
            interval={0}
          />
          <YAxis
            domain={[0, Math.max(...data.map((d) => d.value)) * 1.2]}
            hide
          />
          <Tooltip
            content={<CustomTooltip isUsageFrequency={isUsageFrequency} />}
          />
          <Bar
            dataKey="value"
            fill="url(#gradient)"
            radius={[20, 20, 0, 0]}
            fillOpacity={1}
            className="custom-bar"
            {...(isDashboardPopup && {
              onClick: () => history.push(`/mdr/sysguard/content/Applications`),
            })}
          >
            {isDashboardPopup && (
              <LabelList
                dataKey="value"
                position="top"
                content={({ x, y, value }) => {
                  const formattedValue = shortenedNumber(value);
                  return (
                    <text
                      x={x + 25}
                      y={y - 10}
                      fill="#333"
                      fontSize={12}
                      textAnchor="middle"
                    >
                      {formattedValue}
                    </text>
                  );
                }}
              />
            )}
          </Bar>
          <defs>
            <linearGradient id="gradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#3366FF" />
              <stop offset="100%" stopColor="#A2C8FF" />
            </linearGradient>
          </defs>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CustomBarChart;
